export type ITimberlandAppraisalFormFourthSection = {
    AccountNumber?: string;
    NumberOfAcres?: string;
    LegalDescription?: string;
    HasFormerOwnerPassedAway?: boolean;
    AreYouFormerOwnerSpouse?: boolean;
    HasPropertyOwnershipChanged?: boolean;
    WasAppraisalAllowed?: boolean;
    IsPropertyLocatedWithinCorporateLimits?: boolean;
}

export const TimberlandAppraisalFormFourthSectionInterface = (): ITimberlandAppraisalFormFourthSection => ({
    AccountNumber: undefined,
    NumberOfAcres: undefined,
    LegalDescription: undefined,
    HasPropertyOwnershipChanged: undefined,
    WasAppraisalAllowed: undefined,
    HasFormerOwnerPassedAway: undefined,
    AreYouFormerOwnerSpouse: undefined,
    IsPropertyLocatedWithinCorporateLimits: undefined
})